// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Role extends TrackingModel {
	public RoleId: number = 0;
	public ParentRoleId?: number;
	public UID: string = "";
	public Description?: string;
}